export const ROUTES = {
  about: '/about-us',
  contact: '/contact-us',
  services: '/services',
  trackIt: '/track-it',

  admin: {
    index: '/admin',
    login: '/admin/login',
    add_tracking: '/admin/tracking',
    settings: '/admin/settings',
  },
}

export const SERVICES = [
  'Air Freight',
  'Ocean Freight',
  'Cargo Transportation',
  'Packaging and Storage',
]

export const TRACKING_STATUS = {
  Pending: "Pending",
  'Picked up': "Picked up",
  'On Hold': "On Hold",
  'Out for Delivery': "Out for Delivery",
  'In Transit': "In Transit",
  'Enroute': "Enroute",
  'Cancelled': "Cancelled",
  'Delivered': "Delivered",
  'Returned': "Returned",
}

export const API_URL =
  process.env.NODE_ENV === 'production'
    ? 'https://web-production-5db2d.up.railway.app'
    : 'http://localhost:4000'
